import { useTranslation } from 'react-i18next';
import React from 'react';
import ISubscriptionSelectorProps from '../models/subscription-selector.props.interface';

const SubscriptionSelector: React.FC<ISubscriptionSelectorProps> = ({ subscriptions, subscriptionSelected }) => {
  const { t } = useTranslation();

  return (
    <div className='subscription-selector'>
      <h5>{t('select')}</h5>
      <p>{t('select_2')}</p>
      <div>
        {subscriptions.map(subscription => (
          <div onClick={() => subscriptionSelected(subscription.subdomain)} className='option' key={subscription.id}>
            {subscription.subdomain}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionSelector;
